import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { ProgramsApiHttpService } from '@app/programs/views/services/programs-api-http.service';
import { loadProgram, loadProgramSuccess, loadProgramFailure } from '@app/core/store/programs/actions';

@Injectable()
export class ProgramsEffects {

  public loadLegalDocuments$ = createEffect(() => this.actions$.pipe(
    ofType(loadProgram),
    switchMap(({ id }) => this.programsApiHttpService.getTerms(id).pipe(
        map(program => loadProgramSuccess({ program })),
        catchError(error => of(loadProgramFailure({ error }))),
      ),
    )));

  constructor(private actions$: Actions,
              private programsApiHttpService: ProgramsApiHttpService) {}

}
